class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    /* [BD feat] Search modal — close button (desktop + mobile) */
    const closeButton = this.querySelector('.search-modal__close-button');
    if (closeButton) {
      closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.close();
      });
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (event.target.closest('details').hasAttribute('open')) {
      this.close();
      return;
    }
    /* [BD feat] Mobile — open search first, then close menu drawer (search stays visible via details[open]) */
    const headerDrawer = document.querySelector('header-drawer');
    const isSmallViewport = window.matchMedia('(max-width: 992px)').matches;
    if (
      headerDrawer &&
      isSmallViewport &&
      headerDrawer.querySelector('details')?.hasAttribute('open')
    ) {
      this.open(event);
      const menuSummary = headerDrawer.querySelector('.menu-drawer-container > summary');
      if (menuSummary) {
        headerDrawer.closeMenuDrawer({ preventDefault: () => {} }, this.summaryToggle);
      }
      return;
    }
    this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    if (!this.isOpen()) return;

    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    /* [BD feat] Search modal — clear search input and results after closing details */
    const predictiveSearch = this.querySelector('predictive-search');
    if (predictiveSearch) predictiveSearch.close(true);
    else {
      const searchInput = this.querySelector('input[type="search"]');
      if (searchInput) searchInput.value = '';
    }

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
  }
}

customElements.define('details-modal', DetailsModal);
